<template>
    <header class="navbar">
        <nav>
            <!-- Right side: Logo + Greeting -->
            <div class="nav-right">
                <router-link class="logo" :to="{ name: 'Home' }" @click="states.showVolunteer = false">
                    <img src="@/assets/logo.svg" alt="לוגו" />
                    <span class="logo-text">הדרך אל הלב</span>
                </router-link>
                <span v-if="user" class="greeting">שלום, {{ user.fname }}</span>
            </div>

            <!-- Left side: Actions -->
            <div class="nav-left">
                <!-- Settings dropdown (admin only) -->
                <div v-if="states.user?.isAdmin" class="admin-menu">
                    <button class="admin-btn" @click="toggleAdminMenu">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/>
                            <circle cx="12" cy="12" r="3"/>
                        </svg>
                        <span>הגדרות</span>
                        <svg class="chevron" :class="{ open: showAdminMenu }" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <polyline points="6 9 12 15 18 9"/>
                        </svg>
                    </button>
                    <div v-if="showAdminMenu" class="admin-dropdown" @click="showAdminMenu = false">
                        <!-- Admin options -->
                        <router-link v-if="states.user?.isAdmin" to="/admin/users_manager" class="dropdown-item">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
                                <circle cx="9" cy="7" r="4"/>
                                <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
                                <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                            </svg>
                            <span>ניהול משתמשים</span>
                        </router-link>
                        <router-link v-if="states.user?.isAdmin" to="/admin/request_manager" class="dropdown-item">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
                                <rect x="8" y="2" width="8" height="4" rx="1" ry="1"/>
                                <path d="M9 14l2 2 4-4"/>
                            </svg>
                            <span>ניהול בקשות</span>
                        </router-link>
                        <router-link v-if="states.user?.isAdmin" to="/admin/feedback_manager" class="dropdown-item">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
                            </svg>
                            <span>ניהול משוב</span>
                        </router-link>
                        <router-link v-if="states.user?.isAdmin" to="/admin/background_manager" class="dropdown-item">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                                <circle cx="8.5" cy="8.5" r="1.5"/>
                                <polyline points="21 15 16 10 5 21"/>
                            </svg>
                            <span>ניהול רקע</span>
                        </router-link>
                        <!-- Disabled: Picture approval system disabled -->
                        <router-link v-if="false" to="/admin/pic_auth" class="dropdown-item">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
                                <circle cx="12" cy="13" r="4"/>
                            </svg>
                            <span>ניהול תמונות</span>
                        </router-link>
                        <router-link v-if="states.user?.isAdmin" to="/admin/video_manager" class="dropdown-item">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <polygon points="23 7 16 12 23 17 23 7"/>
                                <rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
                            </svg>
                            <span>ניהול סרטונים</span>
                        </router-link>
                        <router-link v-if="isPointsManager" to="/admin/points_manager" class="dropdown-item">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                            </svg>
                            <span>ניהול נקודות</span>
                            <span v-if="pointsPendingCount > 0" class="points-badge">{{ pointsPendingCount }}</span>
                        </router-link>
                        <router-link v-if="states.user?.isCoordinator" to="/admin/coordinators_manager" class="dropdown-item">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                                <circle cx="9" cy="7" r="4"/>
                                <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                                <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                            </svg>
                            <span>ניהול רכזות</span>
                        </router-link>
                        <!-- Logout -->
                        <div v-if="states.user?.isAdmin" class="dropdown-divider"></div>
                        <button class="dropdown-item logout-dropdown-item" @click="handleLogout">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                                <polyline points="16 17 21 12 16 7"/>
                                <line x1="21" y1="12" x2="9" y2="12"/>
                            </svg>
                            <span>יציאה</span>
                        </button>
                    </div>
                </div>

                <!-- Logout (non-admin users only) -->
                <button v-if="user && !states.user?.isAdmin" class="logout-btn" @click="handleLogout">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                        <polyline points="16 17 21 12 16 7"/>
                        <line x1="21" y1="12" x2="9" y2="12"/>
                    </svg>
                    <span>יציאה</span>
                </button>

                <!-- Tutorial Videos -->
                <button v-if="user" class="inquiry-btn" @click="openTutorialVideos">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"/>
                        <line x1="7" y1="2" x2="7" y2="22"/>
                        <line x1="17" y1="2" x2="17" y2="22"/>
                        <line x1="2" y1="12" x2="22" y2="12"/>
                        <line x1="2" y1="7" x2="7" y2="7"/>
                        <line x1="2" y1="17" x2="7" y2="17"/>
                        <line x1="17" y1="7" x2="22" y2="7"/>
                        <line x1="17" y1="17" x2="22" y2="17"/>
                    </svg>
                    <span>סרטוני הדרכה</span>
                </button>

                <!-- Back button -->
                <button v-if="user" class="back-btn" :class="{ disabled: isHomePage }" :disabled="isHomePage" @click="goBack">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="9 18 15 12 9 6"/>
                    </svg>
                    <span>חזרה</span>
                </button>
            </div>
        </nav>

        <!-- Click outside to close admin menu -->
        <div v-if="showAdminMenu" class="overlay" @click="showAdminMenu = false"></div>

        <!-- Tutorial Videos Modal -->
        <FullScreenModal :show="showTutorialVideos" @close="showTutorialVideos = false">
            <TutorialVideosModal />
        </FullScreenModal>
    </header>
</template>

<script setup>
import useLogout from "@/composables/useLogout"
import getUser from "@/composables/getUser"
import { useRouter } from "vue-router"
import { ref, computed, watch } from 'vue';
import { collection, query, where, getCountFromServer } from 'firebase/firestore';
import { db } from '@/firebase/config';
import { states } from '@/main_store';
import { showModal } from '@/main_store/modal';
import { canManagePoints } from '@/views/admin/checkAdmin';
import FullScreenModal from '@/components/FullScreenModal.vue';
import TutorialVideosModal from '@/components/TutorialVideosModal.vue';

const { user } = getUser()
const { logout } = useLogout()
const router = useRouter()

// Admin menu state
const showAdminMenu = ref(false)

// Points-hub access + pending-work badge (answered reports + unhandled redemptions)
const isPointsManager = computed(() => canManagePoints(states.value.user))
const pointsPendingCount = ref(0)

const fetchPointsPendingCount = async () => {
    try {
        const answeredSnapshot = await getCountFromServer(
            query(collection(db, 'attendance-reports'), where('status', '==', 'answered')))
        const pendingSnapshot = await getCountFromServer(
            query(collection(db, 'point-redemptions'), where('status', '==', 'pending')))
        pointsPendingCount.value = answeredSnapshot.data().count + pendingSnapshot.data().count
    } catch (error) {
        console.error('Failed to fetch points pending count:', error)
    }
}

watch(isPointsManager, (isManager) => {
    if (isManager) {
        fetchPointsPendingCount()
    } else {
        pointsPendingCount.value = 0
    }
}, { immediate: true })

// Back button - disabled on homepage
const isHomePage = computed(() => router.currentRoute.value.name === 'Home')
const goBack = () => {
    if (!isHomePage.value) {
        router.back()
    }
}

// Tutorial Videos modal state
const showTutorialVideos = ref(false)

const toggleAdminMenu = () => {
    showAdminMenu.value = !showAdminMenu.value
}

const handleLogout = async () => {
    const confirmed = await showModal('האם אתה בטוח שברצונך להתנתק?', 'warning', true)
    if (confirmed) {
        await logout()
        router.push({ name: "Login" })
    }
};

// Tutorial Videos
const openTutorialVideos = () => {
    showTutorialVideos.value = true
}
</script>

<style scoped>
.navbar {
    width: 100%;
    background: transparent;
    border-bottom: none;
    position: relative;
    z-index: 100;
}

nav {
    max-width: 1200px;
    margin: 0 auto;
    height: 56px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    direction: rtl;
}

/* Right side */
.nav-right {
    display: flex;
    align-items: center;
    gap: 16px;
}

.logo {
    display: flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
}

.logo img {
    width: 36px;
    height: 36px;
    object-fit: contain;
}

.logo-text {
    font-size: 18px;
    font-weight: 700;
    color: #1f2937;
}

.greeting {
    font-size: 14px;
    color: #6b7280;
    padding-right: 16px;
    border-right: 1px solid #e5e7eb;
}

/* Left side */
.nav-left {
    display: flex;
    align-items: center;
    gap: 8px;
}

/* Icon button */
.icon-btn {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: #f3f4f6;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #4b5563;
    transition: all 0.2s ease;
}

.icon-btn:hover {
    background: #e5e7eb;
    color: #1f2937;
}

/* Inquiry button */
.inquiry-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 14px;
    border-radius: 10px;
    background: #eff6ff;
    border: 1px solid #bfdbfe;
    cursor: pointer;
    color: #2563eb;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;
}

.inquiry-btn:hover {
    background: #dbeafe;
    border-color: #93c5fd;
}

/* Admin button */
.admin-menu {
    position: relative;
}

.admin-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 12px;
    border-radius: 10px;
    background: #f3f4f6;
    border: none;
    cursor: pointer;
    color: #4b5563;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;
}

.admin-btn:hover {
    background: #e5e7eb;
    color: #1f2937;
}

.admin-btn .chevron {
    transition: transform 0.2s ease;
}

.admin-btn .chevron.open {
    transform: rotate(180deg);
}

.admin-dropdown {
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    background: white;
    border-radius: 12px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
    border: 1px solid #e5e7eb;
    min-width: 180px;
    overflow: hidden;
    z-index: 200;
}

.dropdown-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;
    color: #374151;
    text-decoration: none;
    font-size: 14px;
    transition: background 0.15s ease;
}

.dropdown-item svg {
    flex-shrink: 0;
    color: #6b7280;
}

.dropdown-item:hover {
    background: #f3f4f6;
}

.dropdown-item:hover svg {
    color: #4b5563;
}

.overlay {
    position: fixed;
    inset: 0;
    z-index: 99;
}

/* Logout button (non-admin) */
.logout-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 14px;
    border-radius: 10px;
    background: #fef2f2;
    border: 1px solid #fecaca;
    cursor: pointer;
    color: #dc2626;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;
}

.logout-btn:hover {
    background: #fee2e2;
    border-color: #fca5a5;
}

/* Back button */
.back-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 14px;
    border-radius: 10px;
    background: #f3f4f6;
    border: 1px solid #e5e7eb;
    cursor: pointer;
    color: #4b5563;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;
}

.back-btn:hover:not(.disabled) {
    background: #e5e7eb;
    color: #1f2937;
}

.back-btn.disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

/* Dropdown divider */
.dropdown-divider {
    height: 1px;
    background: #e5e7eb;
    margin: 4px 0;
}

/* Logout in dropdown */
.logout-dropdown-item {
    width: 100%;
    background: none;
    border: none;
    cursor: pointer;
    color: #dc2626 !important;
    font-size: 14px;
}

.logout-dropdown-item svg {
    color: #dc2626 !important;
}

.logout-dropdown-item:hover {
    background: #fef2f2 !important;
}

/* Mobile */
@media only screen and (max-width: 600px) {
    nav {
        height: 52px;
        padding: 0 12px;
    }

    .logo img {
        width: 32px;
        height: 32px;
    }

    .logo-text {
        font-size: 16px;
    }

    .greeting {
        display: none;
    }

    .admin-btn span,
    .back-btn span,
    .logout-btn span,
    .inquiry-btn span {
        display: none;
    }

    .admin-btn,
    .back-btn,
    .logout-btn,
    .inquiry-btn {
        width: 40px;
        height: 40px;
        padding: 0;
        justify-content: center;
    }

    .admin-btn .chevron {
        display: none;
    }

    .admin-dropdown {
        position: fixed;
        top: 52px;
        left: 12px;
        right: auto;
    }
}

/* Large screens */
@media only screen and (min-width: 768px) {
    nav {
        height: 64px;
        padding: 0 24px;
    }

    .logo img {
        width: 40px;
        height: 40px;
    }

    .logo-text {
        font-size: 20px;
    }
}

/* Points hub pending-work badge */
.points-badge {
    background: #dc2626;
    color: white;
    border-radius: 10px;
    font-size: 11px;
    padding: 1px 6px;
    min-width: 16px;
    text-align: center;
    margin-right: auto;
}
</style>
